import type { FC } from 'react';

import type { TextFieldProps } from '@mui/material';

import { StyledTextField } from '../select-native/styles';
import Skeleton from '../skeleton';

/**
 * This should only be used if form is not present in parent node
 * If form is present then prefer using ValidatedInputField component
 */

export type TInputField = {
  preload?: boolean;
  width?: number | string;
} & TextFieldProps;

const InputField: FC<TInputField> = ({
  variant = 'outlined',
  margin = 'normal',
  size = 'small',
  preload,
  width,
  SelectProps: _selectProps = {},
  className,
  ...rest
}) => {
  const height = 48;
  if (preload) {
    return <Skeleton width={width} height={height} variant="rectangular" className={` ${className || ''}`} />;
  }

  return <StyledTextField variant={variant} margin={margin} size={size} className={`${className || ''}`} {...rest} />;
};

export default InputField;
